"use client"

import type { WalletModalLabels } from "@shared/web3"
import { useTranslations } from "@/lib/i18n/client"

export function useWalletLabels(): WalletModalLabels {
  const t = useTranslations("wallet")
  return {
    connect: t("connect"),
    disconnect: t("disconnect"),
    network: t("network"),
    title: t("title"),
    subtitle: t("subtitle"),
    detected: t("detected"),
    install: t("install"),
    openApp: t("openApp"),
    scanQr: t("scanQr"),
    moreWallets: t("moreWallets"),
    otherWallets: t("otherWallets"),
    secure: t("secure"),
    connecting: t("connecting"),
    rejected: t("rejected"),
    selectChainTitle: t("selectChainTitle"),
    selectChainSubtitle: t("selectChainSubtitle"),
    back: t("back"),
  }
}
